import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import InformedConsentApi from '../../../../../api/patient/InformedConsentApi';
import { NSPP_INFORMED_CONSENT } from '../../../../../services/i18n/namespaces';

import InformedConsentColumn from './InformedConsentColumn';
import InformedConsentItem from './InformedConsentItem';

import './InformedConsent.scss';

export default function InformedConsent({ studyId, studyName }) {
  const { t } = useTranslation();
  const [informedConsentItems, setInformedConsentItems] = useState({ types: [], languages: [] });

  const updateItems = () => {
    InformedConsentApi.getItemsByStudyId(studyId).then(res => {
      const {
        data: { types, languages }
      } = res;
      setInformedConsentItems({ types, languages });
    });
  };

  useEffect(() => {
    if (studyId) {
      updateItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studyId]);

  const types = informedConsentItems.types.map(item => {
    return (
      <li key={`${item.id}-type`}>
        <InformedConsentItem
          id={item.id}
          label="type"
          current={item.type}
          studyId={studyId}
          updateItems={updateItems}
        />
      </li>
    );
  });

  const languages = informedConsentItems.languages.map(item => {
    return (
      <li key={`${item.id}-language`}>
        <InformedConsentItem
          id={item.id}
          label="language"
          current={item.language}
          studyId={studyId}
          updateItems={updateItems}
        />
      </li>
    );
  });

  return (
    <>
      <section>
        <div className="informed-consent-setup-wrapper p-3 m-0 mt-2 border">
          <div className="informed-consent-setup-header border-bottom-dotted">
            <p>
              {t('informedConsent', { ns: NSPP_INFORMED_CONSENT })}: <span>{studyName}</span>{' '}
            </p>
          </div>
          <div className="informed-consent-setup-columns">
            <InformedConsentColumn label="type" items={types} studyId={studyId} updateItems={updateItems} />
            <InformedConsentColumn label="language" items={languages} studyId={studyId} updateItems={updateItems} />
          </div>
        </div>
      </section>
    </>
  );
}
